import axios from 'axios'

const MIDDLEWARE_URL =
  import.meta.env.VITE_MIDDLEWARE_URL || 'https://trbotrkr.com'

const api = axios.create({
  baseURL: `${MIDDLEWARE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default api
